/* eslint-disable no-console */
import { GraphQLClient } from 'graphql-request';
import { getToken } from '../../Utils/Token';
import config from '../../Config/Environment';

const graphql = async (query, variables) => {
  const token = getToken();
  let graphQLClient;
  if (token) {
    graphQLClient = new GraphQLClient(`${config.endpoint}/`, {
      headers: {
        authorization: token ? `Bearer ${token}` : '',
      },
    });
  } else {
    graphQLClient = new GraphQLClient(`${config.endpoint}/`);
  }

  return graphQLClient.request(query, variables).catch(e => {
    console.error('Error:', e);
    return {
      error: true,
      errorMessage: e.response.errors[0].message,
    };
  });
};

export default graphql;
